import React from 'react';

import { useUser } from '@/providers/UserProvider';
import {
  createIcimLogoutURL,
  logOutUser,
} from '@/helpers/api/user-profile-api';
import { getLocale } from '@/helpers/utils';
import LinkButton from '../ui/link-button/link-button';
import { useGetLibraryConstantsDictionaryData } from '@/providers/ConfigProvider';
import { clearCachedDisplay } from '@/helpers/auth/displayCache';

interface UserProfileProps {
  user: {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
    zipCode: string;
  };
  node_locale: string;
  brandId: string;
  config: any;
}

const UserProfile: React.FC<UserProfileProps> = ({
  user,
  node_locale,
  brandId,
  config,
}) => {
  const { setUser } = useUser();

  const dictionary = useGetLibraryConstantsDictionaryData();

  const signOutButtonClickHandler = () => {
    setUser(null);
    clearCachedDisplay();
    sessionStorage.removeItem('silent_login');
    logOutUser();
  };

  const createProfileURL = () => {
    const locale = getLocale(node_locale);
    return `${process.env.NEXT_PUBLIC_ICIM_PROFILE_URL}/${brandId?.toLocaleLowerCase()}?ui_locales=${locale}&redirect_uri=${config.NEXT_PUBLIC_ICIM_REGISTERED_REDIRECT_URL}`;
  };

  return (
    <div className="max-w-md mx-auto my-12 flex flex-col justify-between h-full text-text-default">
      <div className="h-full w-full">
        <h2 className="text-headingm font-title lg:text-headingxl mb-6 text-text-default">
          {dictionary?.profile}
        </h2>
        <div className="mb-4">
          <p className="text-bodys">{dictionary?.name}*</p>
          <p className="text-bodyl">{user?.firstName || ''}</p>
        </div>
        <div className="mb-4">
          <p className="text-bodys">{dictionary?.surname}</p>
          <p className="text-bodyl">{user?.lastName || ''}</p>
        </div>
        <div className="mb-4">
          <p className="text-bodys">{dictionary?.email}*</p>
          <p className="text-bodyl">{user?.email || ''}</p>
        </div>
        <div className="mb-4">
          <p className="text-bodys">{dictionary?.phone}:</p>
          <p className="text-bodyl">{user?.phoneNumber || ''}</p>
        </div>
        <div className="mb-4">
          <p className="text-bodys">{dictionary?.zipCode}:</p>
          <p className="text-bodyl">{user?.zipCode || ''}</p>
        </div>
      </div>
      <div className="flex-1" />
      <div>
        <LinkButton
          to={createProfileURL()}
          variant="primary"
          size="regular"
          className="w-full text-center"
        >
          {dictionary?.editProfile}
        </LinkButton>
        <LinkButton
          to={createIcimLogoutURL(config)}
          className="mt-4 w-full text-center"
          size="regular"
          variant="secondary"
          onClickHandler={signOutButtonClickHandler}
          isExternalLink
        >
          {dictionary?.signOut}
        </LinkButton>
      </div>
    </div>
  );
};

export default UserProfile;
